import React, { useEffect, useState } from 'react';
import { Grade } from '../types';
// Direct import of the GradeService
import { GradeService } from '../services/grade.service';

interface GradeSelectorProps {
  onSelectGrade: (gradeId: number) => void;
}

const GradeSelector: React.FC<GradeSelectorProps> = ({ onSelectGrade }) => {
  const [grades, setGrades] = useState<Grade[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedGradeId, setSelectedGradeId] = useState<number | ''>('');

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        setLoading(true);
        // Use GradeService directly instead of ApiService
        const gradesData = await GradeService.getAllGrades();
        setGrades(gradesData);
        setError(null);
      } catch (err) {
        console.error('Error fetching grades:', err);
        setError('Failed to fetch grades. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchGrades();
  }, []);

  const handleGradeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const gradeId = parseInt(e.target.value, 10);
    setSelectedGradeId(gradeId);
    onSelectGrade(gradeId);
  };

  if (loading) {
    return <div>Loading grades...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="section">
      <div className="selector">
        <label htmlFor="grade-select">Select Grade:</label>
        <select 
          id="grade-select" 
          value={selectedGradeId} 
          onChange={handleGradeChange}
        >
          <option value="" disabled>Choose a grade</option>
          {grades.map(grade => (
            <option key={grade.id} value={grade.id}>
              {grade.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default GradeSelector;